import { Navigate, useSearchParams } from 'react-router'

import { SignInGate } from '../../components/SignIn/SignInGate'
import { SignInMode } from '../../components/SignIn/SignInPanel'
import { useHostGuard } from '../../lib/hostGuard'
import { signUpRedirectTarget } from '../../lib/signUpUrl'

/** The sign-in panel under a "create your account" heading, then the page `redirect_url` names. */
export function SignUpPage() {
  const { redirecting } = useHostGuard('app')
  const [searchParams] = useSearchParams()
  const target = signUpRedirectTarget(searchParams.get('redirect_url'))

  if (redirecting) return null

  return (
    <SignInGate mode={SignInMode.SIGN_UP}>
      <Navigate to={target} replace />
    </SignInGate>
  )
}
